<div class="termsBox termsText px-2 pt-2">
  <markdown [data]="content()"></markdown>
</div>
